import React from "react";

import { Component } from "../../../../commons/types/component";
import { IconSource } from "../../../../commons/types/icon";
import cn from "../../libs/class-name";
import Headline from "../Headline/Headline";
import Icon from "../Icon/Icon";

interface Props extends Component {
  children: React.ReactNode;
  icon: IconSource;
}

const ProductFilterGroupHeadline = ({ classNames = [], children, icon }: Props) => (
  <div className={cn("ProductFilterGroupHeadline", [], classNames)}>
    <Icon classNames={["ProductFilterGroupHeadline__icon"]} source={icon} />
    <Headline classNames={["ProductFilterGroupHeadline__headline"]}>{children}</Headline>
  </div>
);

export default ProductFilterGroupHeadline;
